import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { environment } from '@env';
import { Article } from '@modules/knowledge/models/article/article';

@Injectable({
  providedIn: 'root'
})
export class ArticleReadTimer {
  private readonly storageKey = 'rt_articles';
  private timerInterval: number | null = null;
  private saveInterval: number | null = null;

  private secondsRead = 0;
  private timeSinceLastScroll = 0;
  private startTime: Date | null = null;
  private article: Article | null = null;

  constructor(
    private router: Router,
    private httpClient: HttpClient
  ) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.stop();
      }
    });

    window.addEventListener('scroll', () => {
      this.timeSinceLastScroll = 0;
    });
  }

  stop(){
    this.endTimer();
    this.flushToApi();
  }

  start(article: Article): void {
    this.endTimer();
    this.startTimer(article);
  }

  private startTimer(article: Article): void {
    this.article = article;
    this.secondsRead = 0;
    this.startTime = new Date();

    this.timerInterval = setInterval(() => {
      if (document.hasFocus() || this.timeSinceLastScroll < 10) {
        this.secondsRead++;
      }

      this.timeSinceLastScroll++;
    }, 1000);

    this.saveInterval = setInterval(() => {
      if (this.timerInterval) {
        this.updateSessionStorage();
      }
    }, 5000);
  }

  private updateSessionStorage(): void {
    // Without an id the read log would be posted for "/articles/undefined".
    if (!this.article?.articleId) {
      return;
    }

    const storage = sessionStorage.getItem(this.storageKey);

    const timerData = storage ? JSON.parse(storage) : {};

    const articleTimerData = timerData[this.article.articleId] ?? {
      startTime: this.startTime,
      version: parseInt(this.article.currentVersion.replace('v', ''))
    };
    articleTimerData.secondsRead = this.secondsRead;
    timerData[this.article.articleId] = articleTimerData;

    sessionStorage.setItem(this.storageKey, JSON.stringify(timerData));
  }

  private endTimer(): void {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
    }
    if (this.saveInterval) {
      clearInterval(this.saveInterval);
    }
  }

  private flushToApi(): void {
    const storage = sessionStorage.getItem(this.storageKey);
    const timerData = storage ? JSON.parse(storage) : null;

    if (timerData) {
      for (const articleId in timerData) {
        const articleTimerData = timerData[articleId];
        this.httpClient.post(environment.apiUrl + '/article_read_logs', {
          article: '/articles/' + articleId,
          start: articleTimerData.startTime,
          secondsRead: articleTimerData.secondsRead,
          version: articleTimerData.version
        }).subscribe(response => {

        });
      }
    }

    sessionStorage.removeItem(this.storageKey);
  }
}
